<template>
  <div class="h-100">
    <a-layout-header class="border-b d-flex bg-white" style="padding: 20px">
      <div style="font-size: 16px;font-weight: bold">用户组管理</div>
    </a-layout-header>
    <a-layout class="h-100 bg-white">
      <a-layout-sider class="bg-white border-r h-100">
        <div style="padding: 10px;">
          <a-space>
            <a-input-search placeholder="组定位" @search="searchUserGroup" />
            <a-button type="primary" icon="plus"  @click="showGroupModal(0, 0)"/>
          </a-space>
          <a-tree :tree-data="userGroup" :replaceFields="{ children:'children', title:'name', key:'id' }">
            <template #title="{ id: treeKey, name }">
              <a-dropdown :trigger="['contextmenu']">
                <span>{{ name }}</span>
                <template #overlay>
                  <a-menu style="width: 100px" @click="({key}) => showGroupModal(treeKey, key)">
                    <a-menu-item :key="1" @click="showGroupModal(treeKey)">
                      <span style="color: #1890ff"><a-icon type="plus-square" theme="filled" />新建</span>
                    </a-menu-item>
                    <a-menu-item :key="2">
                      <span style="color: #1890ff"><a-icon type="edit" theme="filled" />编辑</span>
                    </a-menu-item>
                    <a-menu-item :key="3">
                      <span style="color: #1890ff"><a-icon type="minus-square" theme="filled" />删除</span>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </a-tree>
        </div>
      </a-layout-sider>
      <a-layout-content style="padding: 12px">
        <div class="d-flex" style="margin-bottom: 12px">
          <a-space>
            <a-button type="primary" @click="userAddModal.visible = true">添加用户</a-button>
            <a-button type="danger">移除用户</a-button>
          </a-space>
        </div>
        <a-table :columns="userColumns" :row-selection="rowSelection" :data-source="userList" bordered></a-table>
      </a-layout-content>
    </a-layout>
    <a-modal title="添加用户" :footer="null" v-model="userAddModal.visible" width="70%">
      <a-table
        :columns="userColumns"
        :row-key="record => record.id"
        :row-selection="userAddModal.rowSelection"
        :data-source="userAddModal.userList"
        :loading="userAddModal.loading"
        bordered
        :pagination="false"
      >
        <template #filterDropdown="{ column }">
          <div style="padding: 10px">
            <a-input style="margin-bottom: 10px" size="small" :placeholder="`请输入${column.title}`" v-model="userAddModal.searchParam[column.dataIndex]"/>
            <div class="d-flex">
              <a-button style="margin-right: 15px" block size="small" type="primary" @click="searchUserList(userAddModal.pagination.current, userAddModal.pagination.pageSize, userAddModal.searchParam)">查找</a-button>
              <a-button block size="small" @click="resetSearchParam(column.dataIndex)">重置</a-button>
            </div>
          </div>
        </template>
        <template #filterIcon="filtered, column">
          <a-icon type="search" :style="{ color: userAddModal.searchParam[column.dataIndex].length > 0 ? '#108ee9' : undefined }" />
        </template>
      </a-table>
      <div style="margin-top: 20px" class="d-flex">
        <a-pagination
          :current="userAddModal.pagination.current"
          :page-size="userAddModal.pagination.pageSize"
          :total="userAddModal.pagination.total"
          :page-size-options="userAddModal.pagination.pageSizeOptions"
          show-size-changer
          @change="changeModalPage"
          @showSizeChange="changeModalPageSize"
        />
        <a-space>
          <a-button @click="userAddModal.visible = false">返回</a-button>
          <a-button type="primary" @click="addUserToGroup">添加</a-button>
        </a-space>
      </div>
    </a-modal>
    <a-modal title="用户组" v-model="groupModal.visible" :body-style="{ padding: 0, paddingTop: '10px' }">
      <a-form-model layout="horizontal" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item required label="用户组名">
          <a-input v-model="groupModal.userGroupForm.name" />
        </a-form-model-item>
        <a-form-model-item required label="排序">
          <a-input-number
            :default-value="0"
            :formatter="val => val.replaceAll('.', '')"
            :parser="val => val.replaceAll('.', '')"
            :min="0"
            style="width: 100%"
            v-model="groupModal.userGroupForm.orderId"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { userColumns } from '@/views/System/User/data'
import userApi from '@/api/user'
import adminApi from '@/api/admin'
export default {
  name: 'UserGroup',
  created () {
    userColumns.forEach(col => {
      if (col.dataIndex === 'username' || col.dataIndex === 'name' || col.dataIndex === 'companyName') {
        col.scopedSlots = {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      }
    })
  },
  mounted () {
    adminApi.listUserGroup().then(({ data }) => {
      this.userGroup = data
    }).catch(() => {
      // this.$message.error("请求失败")
    })
    userApi.getUserList(1, 10).then(({ data }) => {
      this.userAddModal.userList = data.records
      this.userAddModal.pagination.current = data.current
      this.userAddModal.pagination.pageSize = data.size
      this.userAddModal.pagination.total = data.total
    }).catch(() => {
      // this.$message.error("请求失败")
    })
  },
  data () {
    const onModalTableChange = (selectedRowKeys) => {
      this.userAddModal.rowSelection.selectedRowKeys = selectedRowKeys
    }
    return {
      userColumns: userColumns,
      userGroup: [
        { name: '用户组1', id: '1' },
        { name: '用户组2', id: '2' },
        { name: '用户组3', id: '3', isLeaf: true }
      ],
      userList: [],
      rowSelection: {},
      userGroupOptionMenu: {
        visible: false,
        x: 0,
        y: 0
      },
      userAddModal: {
        visible: false,
        userList: [],
        loading: false,
        rowSelection: {
          selectedRowKeys: [],
          onChange: onModalTableChange
        },
        searchParam: {
          username: '',
          name: '',
          companyName: ''
        },
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true
        }
      },
      groupModal: {
        visible: false,
        userGroupForm: {
          pid: 0,
          name: '',
          orderId: 0
        }
      }
    }
  },
  methods: {
    async loadUserGroupChildren (node) {
      node.dataRef.children = [
        { name: '用户组11', id: `${node.eventKey}-1` },
        { name: '用户组11', id: `${node.eventKey}-2` }
      ]
      this.userGroup = [...this.userGroup]
    },
    searchUserGroup (value) {
      console.log(value)
    },
    changeModalPage (page, pageSize) {
      if (this.userAddModal.searchParam.username.length > 0 || this.userAddModal.searchParam.name.length > 0 || this.userAddModal.searchParam.name.length > 0) {
        this.searchUserList(page, pageSize, this.userAddModal.searchParam)
      } else {
        this.userAddModal.loading = true
        userApi.getUserList(page, pageSize).then(({ data }) => {
          this.userAddModal.userList = data.records
          this.userAddModal.pagination.current = data.current
          this.userAddModal.pagination.pageSize = data.size
          this.userAddModal.pagination.total = data.total
        }).catch(() => {
          // this.$message.error("请求失败")
        }).finally(() => {
          this.userAddModal.loading = false
        })
      }
    },
    changeModalPageSize (current, size) {
      this.changeModalPage(current, size)
    },
    resetSearchParam (field) {
      this.userAddModal.searchParam[field] = ''
      this.searchUserList(this.userAddModal.pagination.current, this.userAddModal.pagination.pageSize, this.userAddModal.searchParam)
    },
    searchUserList (current = 1, size = 50, param) {
      this.userAddModal.loading = true
      userApi.searchUserList(current, size, param).then(({ data: { current, records, size, total } }) => {
        this.userAddModal.userList = records
        this.userAddModal.pagination.current = current
        this.userAddModal.pagination.pageSize = size
        this.userAddModal.pagination.total = total
      }).catch(({ message }) => {
        this.$message.warning(message)
      }).finally(() => {
        this.userAddModal.loading = false
      })
    },
    addUserToGroup () {
      console.log(this.userAddModal.rowSelection.selectedRowKeys)
      this.userAddModal.visible = false
    },
    showGroupModal (id, key) {
      switch (key) {
        case 0:
          this.groupModal.visible = true
          break
        case 1:
          this.groupModal.visible = true
          break
        case 2:
          adminApi.searchUserGroup(id).then(({ data }) => {
            this.groupModal.userGroupForm = data
          })
          this.groupModal.visible = true
          break
        case 3:
          this.$Mconfirm({
            content: '是否删除该用户组及其下属所有组',
            okText: '确认删除',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              console.log('OK')
            },
            onCancel () {
              console.log('Cancel')
            }
          })
          break
      }
      console.log(id,key)
    }
  }
}
</script>

<style scoped>
>>> .ant-form-item {
  margin-bottom: 10px;
}
</style>
